import { PaintedScene } from '../PaintedScene';

export const LAVA_TUBE_PHASER_KEY = 'LavaTubeScene' as const;
export const LAVA_TUBE_MANIFEST_KEY = 's-410-lava-tube' as const;

export class LavaTubeScene extends PaintedScene {
  constructor() {
    super(LAVA_TUBE_PHASER_KEY, LAVA_TUBE_MANIFEST_KEY);
  }
}
